<template>
  <div :id="index">
    <button class="icon-voice" @click="audioPlay(act.sounds[0])"></button>
    <template v-if="isSelect">
      <div class="item-inner" @click="clickImage($event)">
        <div class="word"><span v-html="getPopupTextElem(eText)" ></span></div>
        <div class="card">
          <div :class="{ correct: isCorrect, incorrect: isInCorrect}"></div>
          <div v-if="!isShowImage" class="aimage"><img src="/static/images/blank.jpg"/></div>
          <div v-else class="aimage" @touchstart="$emit('onTouchStart', act.image)"
               @touchend="$emit('onTouchEnd')" @touchmove="$emit('onTouchEnd')"><img :src="act.image"/></div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="item-inner">
        <div class="word"><span v-html="getPopupTextElem(eText)" ></span></div>
        <div class="card">
          <div :class="{ correct: isCorrect, incorrect: isInCorrect}"></div>
          <div v-if="!isShowImage" class="aimage"><img src="/static/images/blank.jpg"/></div>
          <div v-else class="aimage" @touchstart="$emit('onTouchStart', act.image)"
               @touchend="$emit('onTouchEnd')" @touchmove="$emit('onTouchEnd')"><img :src="act.image"/></div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
// 共通処理
import common from "@/mixin/common";
import runmode from "@/mixin/runmode";
import audio from "@/mixin/audio";
import jquery from "jquery";
import * as constants from "@/mixin/constants";

import Vue from "vue";

export default {
  name: "A3act",
  props: {
    act: Object,
    answer: Object,
    questionState: String,
    index: Number,
    isSelect: Boolean
  },
  data() {
    return {
      // actのテキスト
      eText: "",
      // 正解したか否かを判断するフラグ
      isCorrect: false,
      // 不正解したか否かを判断するフラグ
      isInCorrect: false,
      // 画像を表示するか否かを判断するフラグ
      isShowImage: false
    };
  },
  mixins: [
    common,
    runmode,
    audio,
    constants
  ],
  methods: {
    /**
    /* 初期化処理
     */
    init: function() {
      this.eText = this.act.basicText;
    },
    /**
    /* 画像押下時の処理
     */
    clickImage: function() {
      this.log("A3act start clickImage");

      const self = this;
      const targetID = "#" + this.index + " .aimage";
      const eleS = $(".toparea-image img");

      if (this.answer.basicText == this.act.basicText) {
        // 正解の場合

        // 正解を親に通知
        this.$emit("isCorrect");
        // 正解音声の再生
        this.audioCorrect();
        this.isAudioPlaying = false;
        // 正解画像の表示
        this.isCorrect = true;
        // 正解時アニメーション
        this.setAniTarget();
        this.Animate().then(function() {
          // A3actの変更を元に戻す
          self.isCorrect = false;
          // aniTargetIDを削除する
          $(targetID).removeAttr("id");
          // 移動したテキストを再表示する
          eleS.removeClass("hide");
          Vue.nextTick(function() {
            self.$emit("clickImage");
          });
        });
      } else {
        // 不正解の場合

        // 不正解を親に通知
        this.$emit("isInCorrect");
        // 不正解音声の再生
        this.audioInCorrect();
        this.isAudioPlaying = false;
        // 不正解画像の表示
        this.isInCorrect = true;
        // 親に通知する
        this.setInterval(constants.INCORRECT_INTERVAL).then(function() {
          // A3actの変更を元に戻す
          self.isInCorrect = false;

          Vue.nextTick(function() {
            self.$emit("clickImage");
          });
        });
      }
    },
    /**
     * 全解答表示／日本語翻訳の内容を元に戻す
     */
    changeunDisp: function() {
      // 日本語テキストを英テキストに戻す
      this.eText = this.act.basicText;

      // 画像を非表示に戻す
      this.isShowImage = false;
    },
    /**
     * 日本語翻訳表示ボタン押下処理
     */
    changeDispJapanese: function() {
      this.eText = this.act.japaneseText;
      this.isShowImage = false;
    },
    /**
    /* 全解答表示ボタン押下処理
     */
    changeDispAnswer: function() {
      this.eText = this.act.basicText;
      this.isShowImage = true;
    },
    /**
    /* 出題画像移動アニメーション
     */
    Animate: function() {
      this.log("A3act start Animate");

      const self = this;

      let answerText = this.act.basicText;

      let eleS = $(".toparea-image img");
      let eleD = $("#aniTarget");
      let iconVoice = $(".toparea-play .icon-voice");

      let headerElem = $(".header");

      // 移動元の情報を取得
      let offsetTopS = eleS.offset().top;
      let offsetLeftS = eleS.offset().left;
      let eleWidthS = eleS.outerWidth();
      let eleHeightS = eleS.outerHeight();

      // 移動先の情報を取得
      let offsetTop = eleD.offset().top;
      let offsetLeft = eleD.offset().left;
      let eleWidth = eleD.outerWidth();
      let eleHeight = eleD.outerHeight();

      return new Promise(function(resolve, reject) {
        // 移動元のstyleを変更
        eleS.css({
          top: offsetTopS,
          left: offsetLeftS,
          width: eleWidthS,
          height: eleHeightS
        });
        eleS.addClass("moveinput");

        var animateTop = offsetTop - headerElem.outerHeight();

        // 移動animate実行
        eleS.stop().animate({
          top: animateTop,
          left: offsetLeft,
          width: eleWidth,
          height: eleHeight,
          zIndex: 2
        }, 500, function() {
          setTimeout(function() {
            eleS.addClass("hide");
            eleS.removeClass("moveinput");
            eleS.css({
              top: "",
              left: "",
              width: "",
              height: ""
            });
            resolve();
          }, 1000);
        });
      });
    },
    /**
    /* 正解のactにaniTargetIDを付与する
     */
    setAniTarget: function() {
      var targetID = "#" + this.index + " .aimage";
      $(targetID).attr("id", "aniTarget");
    }
  },
  mounted: function() {
    this.init();
  },
  watch: {
    /**
    /* 全問題の完了状態を監視する
     */
    questionState: function(newstatus) {
      this.log("A3act watch questionState");

      var eleS = $(".toparea-image img");
      if (newstatus === "end") {
        this.isShowImage = true;
        eleS.addClass("hide");
      }
    },
    /**
     * ツールバー「日本語翻訳を表示する」の選択状態を監視する
     */
    dispJapaneseStatus: function(newstatus) {
      this.log("A3act watch dispJapaneseStatus");

      if (this.dispJapaneseStatus == false) {
        if (this.dispAllAnswerStatus == false) {
          this.changeunDisp();
        }
      } else {
        this.changeDispJapanese();
      }
    },
    /**
     * ツールバー「全解答を表示する」の選択状態を監視する
     */
    dispAllAnswerStatus: function(newstatus) {
      this.log("A3act watch dispAllAnswerStatus");

      if (this.dispAllAnswerStatus == false) {
        if (this.dispJapaneseStatus == false) {
          this.changeunDisp();
        }
      } else {
        this.changeDispAnswer();
      }
    },
    /**
    /* 音声再生状態を監視する
     */
    isAudioPlaying: function(newstatus) {
      this.log("A3act watch isAudioPlaying");

      var iconVoice = $(".icon-voice");

      if (this.isAudioPlaying) {
        // 音声再生ボタンを無効にする
        iconVoice.addClass("disabled");
        $(iconVoice).prop("disabled", true);
      } else {
        // 音声再生ボタンを有効にする
        iconVoice.removeClass("disabled");
        $(iconVoice).prop("disabled", false);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/style/card";
</style>



// WEBPACK FOOTER //
// A3act.vue?71f9f8f4